var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "grid-x hide-for-print" },
        [
          _c("div", { staticClass: "cell auto" }),
          _vm._v(" "),
          _c("print-button"),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pega-photo-clip-sp-caution-text" }, [
        _vm._v(
          "\n    ※「インタビュー」「フォトクリップ」は掲載時ご利用の場合のみ表示されます。\n  "
        ),
      ]),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }